import axios from 'axios';
import { BASE_URL, PLAYLIST_API_PATH, VIDEO_ASSET_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import {
  FeedValidationResult,
  PlaylistInterface,
  RecoverResult,
} from '../types/playlistType';

class PlaylistApiService {
  constructor(private apiService: ApiService<PlaylistInterface>) {}

  public async fetch(params?: URLSearchParams): Promise<FetchResult<PlaylistInterface>> {
    return this.apiService.fetch(params);
  }

  public async fetchById(id: number, params?: Record<string, string>): Promise<PlaylistInterface> {
    return this.apiService.fetchById(id, params);
  }

  public async create(playlist: PlaylistInterface): Promise<PlaylistInterface> {
    return await this.apiService.create(playlist);
  }

  public async update(id: number, playlist: PlaylistInterface): Promise<void> {
    await this.apiService.update(id, playlist);
  }

  public async validateFeed(playlistId: number): Promise<FeedValidationResult> {
    const response = await axios.post(
      `${BASE_URL}${PLAYLIST_API_PATH}${playlistId}/validate-feed/`
    );
    return response.data;
  }

  public async recoverVideo(videoId: number): Promise<RecoverResult> {
    const response = await axios.post(
      `${BASE_URL}${VIDEO_ASSET_API_PATH}${videoId}/recover/`
    );
    return response.data;
  }
}

export const playlistApiService = new PlaylistApiService(
  new ApiService<PlaylistInterface>(PLAYLIST_API_PATH)
);
